import { Component } from "react";

class EntryPagesChildClass extends Component {
    static getElbenwald(features, elbenwaldItems, cliData, cinemas) {
        if(cliData && elbenwaldItems && cinemas && features.has_merchandising)  {
            const currentCinema = cliData.currentCinemaId
            
            return {
                items:    elbenwaldItems ? elbenwaldItems : {},
                settings: cinemas[currentCinema].scope.elbenwaldSettings ? cinemas[currentCinema].scope.elbenwaldSettings : {}
            }
        } else {
            return {
                items: {},
                settings: {}
            }
        }
    }
}

export default EntryPagesChildClass